export const getGridArea=(names)=>
    names.map(name=>`
     .${name}{ grid-area:${name} }`
    );
